import { Radio } from 'antd'
import cn from 'classnames'

import Typography from 'components/UI/Typography/Typography'

import styles from './Option.module.css'

export type OptionProps = {
  name: string
  legend?: string
  value: string | boolean
  price?: string
  checkedValue?: string | boolean
  dataCy?: string
}

const Option = ({
  name,
  legend = '',
  value,
  price = null,
  checkedValue = null,
  dataCy = '',
}: OptionProps): JSX.Element => (
  <Radio
    value={value}
    className={cn(styles.option, {
      [styles.checked]: checkedValue === value,
    })}
  >
    <div className={styles.main} data-cy={dataCy}>
      <Typography.BodyBold>{name}</Typography.BodyBold>

      {price && (
        <div className={styles.priceWrapper}>
          <Typography.H6 theme="tertiary">{price}</Typography.H6>
        </div>
      )}
    </div>

    {legend && (
      <Typography.BodySmall className={styles.legend}>
        {legend}
      </Typography.BodySmall>
    )}
  </Radio>
)

export default Option
